"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryWithCopyButton = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const utils_1 = require("../../helpers/utils");
require("./types");
const CopyButton_1 = require("../CopyButton");
const SummaryWithCopyButton = ({ summaryData }) => {
    const wizardSummaryFieldsets = utils_1.getWizardSummaryFieldsets(summaryData);
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.m },
        react_1.default.createElement(CopyButton_1.CopyButton, { data: summaryData, dataMapper: utils_1.getTextSummaryForClipboard }),
        react_1.default.createElement(components_1.WizardSummary, { fieldsets: wizardSummaryFieldsets })));
};
exports.SummaryWithCopyButton = SummaryWithCopyButton;
exports.SummaryWithCopyButton.displayName = 'SummaryWithCopyButton';
//# sourceMappingURL=SummaryWithCopyButton.js.map